import { render } from "./SubSecondDashboard.vue?vue&type=template&id=18c95892"
import script from "./SubSecondDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SubSecondDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SubSecondStreaming/SubSecondDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c95892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c95892', __exports__)) {
    api.reload('18c95892', __exports__)
  }
  
  module.hot.accept("./SubSecondDashboard.vue?vue&type=template&id=18c95892", () => {
    api.rerender('18c95892', render)
  })

}


export default __exports__